<template>
    <div class="tab-content">
        <div class="tab-pane active" role="tabpanel">
            <div class="card-body">
                <div class="row">
                    <input
                        v-model="filter_ba_fg"
                        type="text"
                        class="form-control mb-3 col-7"
                        placeholder="Filter by Food Group"
                    />
                    <div class="col-5 mt-2">
                        <span class="pull-right">
                            <router-link tag="a" :to="{ name: 'smartfilter.bafg.create' }">
                                New Food Group
                            </router-link>
                        </span>
                    </div>
                </div>
                <div class="clearfix"></div>
                <table v-if="filteredFgs.length > 0" class="table table-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Food Groups</th>
                            <th>Business Activity</th>
                            <th>Extra data</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <app-bafg
                            v-for="(bafg, index) in filteredFgs"
                            :key="bafg.id"
                            :index="index"
                            :bafg="bafg"
                            @removeBaFoodGroup="removeBaFoodGroup"
                        >
                        </app-bafg>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import appBafg from './FoodGroupTableRow';
import axios from 'axios';

export default {
    components: {
        appBafg
    },
    data() {
        return {
            groups: [],
            filter_ba_fg: ''
        };
    },
    computed: {
        filteredFgs() {
            return this.groups.filter(el => {
                if (!el.food_group.name) {
                    return false;
                }
                return el.food_group.name.toLowerCase().match(this.filter_ba_fg.toLowerCase());
            });
        }
    },
    created() {
        this.fetchFoodGroups();
    },
    methods: {
        fetchFoodGroups() {
            axios
                .get('/api/superadmin/business-activity/food-groups')
                .then(res => {
                    this.groups = res.data;
                })
                .catch(error => console.error(error));
        },
        removeBaFoodGroup(index) {
            this.groups.splice(index, 1);
        }
    }
};
</script>
